// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   Status, feedback and loading

   The palette has four hues, so status cannot be carried by colour: orange
   serves both danger and warning, blue serves both success and info. Every
   chip below therefore pairs its tint with a text label, and the shapes are
   sized so the label is always legible — that label is the actual status
   signal, the colour only groups it.
   ════════════════════════════════════════════════════════════════════════ */

/* ── Status chips ───────────────────────────────────────────────────────── */
html.m-app .m-chip,
html.m-app .chip,
html.m-app :is(.status-badge, .order-status, .ntf-badge, .oh-status, .badge-in, .badge-low, .badge-oos) {
  display: inline-flex;
  align-items: center;
  gap: var(--m-1);
  height: 24px;
  padding: 0 var(--m-2);
  border-radius: var(--m-r-pill);
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-semibold);
  line-height: 1;
  letter-spacing: 0.01em;
  white-space: nowrap;
  border: 1px solid transparent;
}

html.m-app .m-chip svg,
html.m-app .chip svg {
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
}

/* Tones. Each is a tinted fill plus a readable foreground; the icon and the
   label inside are what distinguish, say, "Delivered" from "Cancelled". */
html.m-app .m-chip-info,
html.m-app .m-chip-active {
  background: var(--color-secondary-soft);
  color: var(--color-secondary-text);
  border-color: color-mix(in srgb, var(--color-secondary) 26%, transparent);
}

html.m-app .m-chip-attention,
html.m-app .m-chip-pending {
  background: var(--color-primary-soft);
  color: var(--color-text-primary);
  border-color: color-mix(in srgb, var(--color-primary) 34%, transparent);
}

html.m-app .m-chip-neutral,
html.m-app .m-chip-inactive {
  background: var(--m-surface-sunken);
  color: var(--color-text-secondary);
  border-color: var(--m-hairline);
}

html.m-app .m-chip-strong {
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}

/* ── Filter chips ───────────────────────────────────────────────────────
   Selectable chips are taller than status chips because they're targets,
   not labels. */
html.m-app .m-chip-btn,
html.m-app .active-filter-tag {
  display: inline-flex;
  align-items: center;
  gap: var(--m-1);
  height: 36px;
  min-height: 36px;
  padding: 0 var(--m-3);
  border-radius: var(--m-r-pill);
  border: 1px solid var(--m-hairline-strong);
  background: var(--m-surface-card);
  color: var(--color-text-primary);
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-medium);
  white-space: nowrap;
  scroll-snap-align: start;
}

html.m-app .m-chip-btn[aria-pressed="true"],
html.m-app .m-chip-btn.active {
  background: var(--color-secondary);
  border-color: var(--color-secondary);
  /* Navy on blue: 5.6:1. White would be 3.1:1 and fail AA. */
  color: var(--color-text-on-secondary);
  font-weight: var(--m-fw-semibold);
}

/* ── Alerts ─────────────────────────────────────────────────────────────── */
html.m-app .alert {
  display: flex;
  align-items: flex-start;
  gap: var(--m-3);
  padding: var(--m-3);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  margin-bottom: var(--m-3);
}

html.m-app .alert svg { flex: 0 0 auto; margin-top: 1px; }

/* ── Toasts / snackbars ─────────────────────────────────────────────────
   Above the bottom nav, not over it, and never over the sticky action bar
   either — a toast that covers Place Order is worse than no toast. */
html.m-app .toast-stack {
  position: fixed;
  left: var(--m-gutter);
  right: var(--m-gutter);
  bottom: calc(var(--m-bottomnav-total) + var(--m-3));
  top: auto;
  z-index: 240;
  display: flex;
  flex-direction: column-reverse;
  gap: var(--m-2);
  pointer-events: none;
}

html.m-app .m-has-sticky ~ .toast-stack,
html.m-app body:has(.m-sticky-actions) .toast-stack {
  bottom: calc(var(--m-bottomnav-total) + var(--m-control-lg) + var(--m-5));
}

html.m-app .toast {
  display: flex;
  align-items: center;
  gap: var(--m-3);
  width: 100%;
  min-height: var(--m-control);
  padding: var(--m-3);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-secondary);
  line-height: var(--m-lh-snug);
  /* Inverse surface so a toast reads as a system message rather than
     another card in the page. */
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
  box-shadow: var(--m-shadow-raised);
  pointer-events: auto;
  animation: m-toast-in var(--m-dur) var(--m-ease-out);
}

html.m-app[data-theme="dark"] .toast {
  background: var(--m-surface-raised);
  color: var(--color-text-primary);
  border: 1px solid var(--m-hairline);
}

html.m-app .toast-icon {
  flex: 0 0 auto;
  display: inline-flex;
  width: var(--m-icon); height: var(--m-icon);
}

html.m-app .toast-undo,
html.m-app .toast-dismiss {
  flex: 0 0 auto;
  min-height: 36px;
  padding: 0 var(--m-2);
  margin-left: auto;
  border: none;
  border-radius: var(--m-r-xs);
  background: transparent;
  color: inherit;
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-semibold);
  text-decoration: none;
}

@keyframes m-toast-in {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  html.m-app .toast { animation: none; }
}

/* ── Skeletons ──────────────────────────────────────────────────────────
   A skeleton that matches the shape of what's coming makes the wait feel
   shorter than a spinner does, because the layout doesn't jump on arrival. */
html.m-app .skeleton {
  border-radius: var(--m-r-xs);
  background: linear-gradient(
    90deg,
    var(--m-surface-sunken) 25%,
    color-mix(in srgb, var(--color-brand-navy) 9%, var(--color-brand-white)) 37%,
    var(--m-surface-sunken) 63%
  );
  background-size: 400% 100%;
  animation: m-shimmer 1.4s ease-in-out infinite;
}

html.m-app[data-theme="dark"] .skeleton {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.04) 25%,
    rgba(255, 255, 255, 0.08) 37%,
    rgba(255, 255, 255, 0.04) 63%
  );
  background-size: 400% 100%;
}

@keyframes m-shimmer {
  from { background-position: 100% 50%; }
  to   { background-position: 0 50%; }
}

@media (prefers-reduced-motion: reduce) {
  html.m-app .skeleton { animation: none; }
}

/* ── Empty states ───────────────────────────────────────────────────────
   The web version centres a large illustration in a tall card with two
   equally-weighted buttons. On a phone that's most of a screen for a
   message. Compact it, and let one action lead. */
html.m-app .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--m-2);
  padding: var(--m-8) var(--m-5);
  margin: 0;
}

html.m-app .empty-state svg,
html.m-app .empty-state img {
  width: 56px;
  height: 56px;
  opacity: 0.4;
  margin-bottom: var(--m-1);
}

html.m-app .empty-state h2,
html.m-app .empty-state h3 {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-semibold);
  margin: 0;
}

html.m-app .empty-state p {
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
  max-width: 30ch;
  margin: 0 0 var(--m-2);
}

/* ── Inline loading ─────────────────────────────────────────────────────── */
html.m-app .loading,
html.m-app .loading-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--m-2);
  padding: var(--m-6) var(--m-gutter);
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
}

/* ── Pull to refresh ────────────────────────────────────────────────────── */
html.m-app .ptr-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  color: var(--color-secondary);
}

/* ── Progress / steps ───────────────────────────────────────────────────
   Checkout's step rail: numbers stay, labels shrink, and the whole thing
   fits one line instead of wrapping. */
html.m-app .checkout-steps,
html.m-app .m-steps {
  display: flex;
  align-items: center;
  gap: var(--m-1);
  padding: var(--m-3) var(--m-gutter);
}

html.m-app .step {
  display: flex;
  align-items: center;
  gap: var(--m-2);
  flex: 1 1;
  min-width: 0;
}

html.m-app .step-number {
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-bold);
}

html.m-app .step-label {
  font-size: var(--m-fs-caption);
  font-weight: var(--m-fw-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/mobile/status.css"],"names":[],"mappings":"AAAA;;;;;;;;6EAQ6E;;AAE7E,8EAA8E;AAC9E;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAAiC;EACjC,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;0EAC0E;AAC1E;;EAEE,uCAAuC;EACvC,kCAAkC;EAClC,yEAAyE;AAC3E;;AAEA;;EAEE,qCAAqC;EACrC,gCAAgC;EAChC,uEAAuE;AACzE;;AAEA;;EAEE,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;;gBAEgB;AAChB;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,0CAA0C;EAC1C,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,2DAA2D;EAC3D,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,wBAAwB,cAAc,EAAE,eAAe,EAAE;;AAEzD;;qEAEqE;AACrE;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,mDAAmD;EACnD,SAAS;EACT,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B;gCAC8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,kCAAkC;EAClC,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB,EAAE,qBAAqB;AAC7C;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc;EACd,gCAAgC;EAChC,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,oBAAoB,eAAe,EAAE;AACvC;;AAEA;;6EAE6E;AAC7E;EACE,4BAA4B;EAC5B;;;;;GAKC;EACD,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,uBAAuB,eAAe,EAAE;AAC1C;;AAEA;;;kDAGkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAEE,iCAAiC;EACjC,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,sBAAsB;AACxB;;AAEA,8EAA8E;AAC9E;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;uCAEuC;AACvC;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   Status, feedback and loading\n\n   The palette has four hues, so status cannot be carried by colour: orange\n   serves both danger and warning, blue serves both success and info. Every\n   chip below therefore pairs its tint with a text label, and the shapes are\n   sized so the label is always legible — that label is the actual status\n   signal, the colour only groups it.\n   ════════════════════════════════════════════════════════════════════════ */\n\n/* ── Status chips ───────────────────────────────────────────────────────── */\nhtml.m-app .m-chip,\nhtml.m-app .chip,\nhtml.m-app :is(.status-badge, .order-status, .ntf-badge, .oh-status, .badge-in, .badge-low, .badge-oos) {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--m-1);\n  height: 24px;\n  padding: 0 var(--m-2);\n  border-radius: var(--m-r-pill);\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-semibold);\n  line-height: 1;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  border: 1px solid transparent;\n}\n\nhtml.m-app .m-chip svg,\nhtml.m-app .chip svg {\n  width: 12px;\n  height: 12px;\n  flex: 0 0 auto;\n}\n\n/* Tones. Each is a tinted fill plus a readable foreground; the icon and the\n   label inside are what distinguish, say, \"Delivered\" from \"Cancelled\". */\nhtml.m-app .m-chip-info,\nhtml.m-app .m-chip-active {\n  background: var(--color-secondary-soft);\n  color: var(--color-secondary-text);\n  border-color: color-mix(in srgb, var(--color-secondary) 26%, transparent);\n}\n\nhtml.m-app .m-chip-attention,\nhtml.m-app .m-chip-pending {\n  background: var(--color-primary-soft);\n  color: var(--color-text-primary);\n  border-color: color-mix(in srgb, var(--color-primary) 34%, transparent);\n}\n\nhtml.m-app .m-chip-neutral,\nhtml.m-app .m-chip-inactive {\n  background: var(--m-surface-sunken);\n  color: var(--color-text-secondary);\n  border-color: var(--m-hairline);\n}\n\nhtml.m-app .m-chip-strong {\n  background: var(--color-surface-inverse);\n  color: var(--color-text-on-inverse);\n}\n\n/* ── Filter chips ───────────────────────────────────────────────────────\n   Selectable chips are taller than status chips because they're targets,\n   not labels. */\nhtml.m-app .m-chip-btn,\nhtml.m-app .active-filter-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--m-1);\n  height: 36px;\n  min-height: 36px;\n  padding: 0 var(--m-3);\n  border-radius: var(--m-r-pill);\n  border: 1px solid var(--m-hairline-strong);\n  background: var(--m-surface-card);\n  color: var(--color-text-primary);\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-medium);\n  white-space: nowrap;\n  scroll-snap-align: start;\n}\n\nhtml.m-app .m-chip-btn[aria-pressed=\"true\"],\nhtml.m-app .m-chip-btn.active {\n  background: var(--color-secondary);\n  border-color: var(--color-secondary);\n  /* Navy on blue: 5.6:1. White would be 3.1:1 and fail AA. */\n  color: var(--color-text-on-secondary);\n  font-weight: var(--m-fw-semibold);\n}\n\n/* ── Alerts ─────────────────────────────────────────────────────────────── */\nhtml.m-app .alert {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--m-3);\n  padding: var(--m-3);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .alert svg { flex: 0 0 auto; margin-top: 1px; }\n\n/* ── Toasts / snackbars ─────────────────────────────────────────────────\n   Above the bottom nav, not over it, and never over the sticky action bar\n   either — a toast that covers Place Order is worse than no toast. */\nhtml.m-app .toast-stack {\n  position: fixed;\n  left: var(--m-gutter);\n  right: var(--m-gutter);\n  bottom: calc(var(--m-bottomnav-total) + var(--m-3));\n  top: auto;\n  z-index: 240;\n  display: flex;\n  flex-direction: column-reverse;\n  gap: var(--m-2);\n  pointer-events: none;\n}\n\nhtml.m-app .m-has-sticky ~ .toast-stack,\nhtml.m-app body:has(.m-sticky-actions) .toast-stack {\n  bottom: calc(var(--m-bottomnav-total) + var(--m-control-lg) + var(--m-5));\n}\n\nhtml.m-app .toast {\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  width: 100%;\n  min-height: var(--m-control);\n  padding: var(--m-3);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-secondary);\n  line-height: var(--m-lh-snug);\n  /* Inverse surface so a toast reads as a system message rather than\n     another card in the page. */\n  background: var(--color-surface-inverse);\n  color: var(--color-text-on-inverse);\n  box-shadow: var(--m-shadow-raised);\n  pointer-events: auto;\n  animation: m-toast-in var(--m-dur) var(--m-ease-out);\n}\n\nhtml.m-app[data-theme=\"dark\"] .toast {\n  background: var(--m-surface-raised);\n  color: var(--color-text-primary);\n  border: 1px solid var(--m-hairline);\n}\n\nhtml.m-app .toast-icon {\n  flex: 0 0 auto;\n  display: inline-flex;\n  width: var(--m-icon); height: var(--m-icon);\n}\n\nhtml.m-app .toast-undo,\nhtml.m-app .toast-dismiss {\n  flex: 0 0 auto;\n  min-height: 36px;\n  padding: 0 var(--m-2);\n  margin-left: auto;\n  border: none;\n  border-radius: var(--m-r-xs);\n  background: transparent;\n  color: inherit;\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-semibold);\n  text-decoration: none;\n}\n\n@keyframes m-toast-in {\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html.m-app .toast { animation: none; }\n}\n\n/* ── Skeletons ──────────────────────────────────────────────────────────\n   A skeleton that matches the shape of what's coming makes the wait feel\n   shorter than a spinner does, because the layout doesn't jump on arrival. */\nhtml.m-app .skeleton {\n  border-radius: var(--m-r-xs);\n  background: linear-gradient(\n    90deg,\n    var(--m-surface-sunken) 25%,\n    color-mix(in srgb, var(--color-brand-navy) 9%, var(--color-brand-white)) 37%,\n    var(--m-surface-sunken) 63%\n  );\n  background-size: 400% 100%;\n  animation: m-shimmer 1.4s ease-in-out infinite;\n}\n\nhtml.m-app[data-theme=\"dark\"] .skeleton {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.04) 25%,\n    rgba(255, 255, 255, 0.08) 37%,\n    rgba(255, 255, 255, 0.04) 63%\n  );\n  background-size: 400% 100%;\n}\n\n@keyframes m-shimmer {\n  from { background-position: 100% 50%; }\n  to   { background-position: 0 50%; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html.m-app .skeleton { animation: none; }\n}\n\n/* ── Empty states ───────────────────────────────────────────────────────\n   The web version centres a large illustration in a tall card with two\n   equally-weighted buttons. On a phone that's most of a screen for a\n   message. Compact it, and let one action lead. */\nhtml.m-app .empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: var(--m-2);\n  padding: var(--m-8) var(--m-5);\n  margin: 0;\n}\n\nhtml.m-app .empty-state svg,\nhtml.m-app .empty-state img {\n  width: 56px;\n  height: 56px;\n  opacity: 0.4;\n  margin-bottom: var(--m-1);\n}\n\nhtml.m-app .empty-state h2,\nhtml.m-app .empty-state h3 {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-semibold);\n  margin: 0;\n}\n\nhtml.m-app .empty-state p {\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n  max-width: 30ch;\n  margin: 0 0 var(--m-2);\n}\n\n/* ── Inline loading ─────────────────────────────────────────────────────── */\nhtml.m-app .loading,\nhtml.m-app .loading-inline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--m-2);\n  padding: var(--m-6) var(--m-gutter);\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n}\n\n/* ── Pull to refresh ────────────────────────────────────────────────────── */\nhtml.m-app .ptr-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  color: var(--color-secondary);\n}\n\n/* ── Progress / steps ───────────────────────────────────────────────────\n   Checkout's step rail: numbers stay, labels shrink, and the whole thing\n   fits one line instead of wrapping. */\nhtml.m-app .checkout-steps,\nhtml.m-app .m-steps {\n  display: flex;\n  align-items: center;\n  gap: var(--m-1);\n  padding: var(--m-3) var(--m-gutter);\n}\n\nhtml.m-app .step {\n  display: flex;\n  align-items: center;\n  gap: var(--m-2);\n  flex: 1 1 0;\n  min-width: 0;\n}\n\nhtml.m-app .step-number {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-bold);\n}\n\nhtml.m-app .step-label {\n  font-size: var(--m-fs-caption);\n  font-weight: var(--m-fw-medium);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
